import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { getWrapperProps } from './styles';

/**
 * Regions are structural, not something an editor inserts by hand — the parent
 * Tabs block creates and removes them as the layout preset changes. So there is
 * no inspector here; the only affordance is the label, which names the area so
 * the canvas is readable when two regions sit side by side.
 *
 * The label comes from the preset that created the region rather than from a
 * fixed vocabulary, so a preset can call its areas whatever suits it.
 */
export default function Edit( { attributes } ) {
	const { label } = attributes;

	const blockProps = useBlockProps( getWrapperProps( attributes ) );

	// `children` is pulled out of the props rather than spread with them:
	// spreading and then rendering it again would mount the inner blocks twice.
	const { children, ...innerBlocksProps } = useInnerBlocksProps( blockProps, {
		templateLock: false,
	} );

	return (
		<div { ...innerBlocksProps }>
			{ label && (
				<span
					className="brandy-tabs__region-label"
					contentEditable={ false }
				>
					{ label }
				</span>
			) }
			{ children }
		</div>
	);
}
